(ns app.front.view.inspections.photos-section
  (:require [app.domain.attachment.model :as attachment-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.file.download :as file-download]
            [app.front.file.upload :as upload]
            [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.ui.modal :as ui-modal]
            [app.front.ui.multi-select :as ui-ms]
            [app.front.ui.section :as section]
            [app.front.ui.separator :as ui-sep]
            [app.front.util :as futil]
            [app.front.view.workspace.subs :as ws-subs]
            [app.rich-text :as rich-text]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.front.icons :as i]
            [core.util.string :as str-util]
            [goog.string :as gstr]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-db
  ::open-edit-photo-modal
  (fn [db [_ file]]
    (assoc db ::edit-photo-modal (-> {:open?   true
                                      :file-id (:db/id file)}
                                     (merge file)
                                     (assoc :related-deficiencies (-> file
                                                                      :inspection.deficiency/_photos
                                                                      du/entity-id-set))))))

(rf/reg-event-db
  ::save-description
  (fn [db [_ description]]
    (assoc-in db [::edit-photo-modal :file/description] description)))

(rf/reg-event-db
  ::save-deficiencies
  (fn [db [_ deficiency-ids]]
    (assoc-in db [::edit-photo-modal :related-deficiencies] deficiency-ids)))

(rf/reg-event-db
  ::close-edit-photo-modal
  (fn [db _]
    (dissoc db ::edit-photo-modal)))

(rf/reg-event-fx
  ::save-success
  (fn [_ [_ status resp]]
    (let [key    (first (keys resp))
          value  (first (vals resp))
          merged {key (merge value {:recently-added [:assoc true]})}]
      {:dispatch [::entities/apply-changes status merged]})))

(rf/reg-event-fx
  ::remove-success
  (fn [_ [_ file-id _ _]]
    {:dispatch-n [[::close-edit-photo-modal]
                  [::entities/remove-entity file-id]]}))


(rf/reg-event-fx
  ::save-edit-photo-modal
  (fn [{:keys [db]} [_ execution]]
    {:comm/command {:command    :process/apply-signal
                    :data       {:entity-id      (-> execution :db/id)
                                 :process/signal [:process.signal/edit-inspection-file
                                                  {:file-id              (-> db ::edit-photo-modal :file-id)
                                                   :file-description     (-> db ::edit-photo-modal :file/description)
                                                   :related-deficiencies (-> db ::edit-photo-modal :related-deficiencies)}]}
                    :on-success [::entities/apply-changes]}
     :fx           [[:dispatch [::close-edit-photo-modal]]]}))

(rf/reg-event-fx
  ::delete-attachment
  (fn [_ [_ file-id target]]
    {:comm/command {:command    :process/apply-signal
                    :data       {:entity-id      (-> target :db/id)
                                 :process/signal [:process.signal/delete-inspection-file
                                                  {:file-id file-id}]}
                    :on-success [::remove-success file-id]}}))


(rf/reg-event-db ::set-file-id-to-delete
  (fn [db [_ file-id]]
    (assoc db ::file-id-to-delete file-id)))

(rf/reg-sub ::file-id-to-delete :-> ::file-id-to-delete)

(rf/reg-sub
  ::edit-photo-data
  (fn [db _]
    (get db ::edit-photo-modal)))

(rf/reg-sub
  ::edit-photo-modal-open?
  (fn [db _]
    (get-in db [::edit-photo-modal :open?])))


(rf/reg-sub ::deficiency-linking-enabled?
  :<- [::ff/enabled? :feature-flag.id/deficiency-photo-linking]
  :<- [::ws-subs/has-feature? :group.feature/deficiency-numbering]
  (fn [[linking-enabled? deficiency-numbering-enabled?]]
    (and linking-enabled? deficiency-numbering-enabled?)))


(rf/reg-sub ::deficiencies-for-linking
  (fn [[_ inspection]]
    (rf/subscribe [::entities/entities {:entity/type   :entity.type/inspection-deficiency
                                        :entity/parent (:db/id inspection)}]))
  (fn [deficiencies]
    (->> deficiencies
         (remove (du/in-state-fn :inspection.deficiency.state/removed))
         (filter :inspection.deficiency/number))))


(defn- add-inspection-attachment [inspection-id target-entity file-id filename content-type md5]
  (>evt [:app.front.process/signal
         target-entity
         [:process.signal/add-inspection-file
          {:inspection-id     inspection-id
           :file-id           file-id
           :file-description  ""
           :file/filename     filename
           :file/content-type content-type
           :file/category     :file.category/inspection-attachment
           :file/md5          md5}]
         {:on-done [::save-success]}]))


(defn deficiency-label [{:inspection.deficiency/keys [number reference description]}]
  (->> [number (rich-text/join-rich-text-content reference) (rich-text/join-rich-text-content description)]
       (remove str/blank?)
       (str/join " / ")))


(defn deficiency-select [{:keys [can-edit? tr inspection]} related-entities]
  (when (<sub [::deficiency-linking-enabled?])
    (let [deficiencies (<sub [::deficiencies-for-linking inspection])
          label-text   (tr [:inspection/photo-related-deficiencies])
          val->str     #(-> deficiencies
                            (p/find-first {:db/id %})
                            deficiency-label)]
      [:div.mt-2
       (if can-edit?
         [ui-ms/multi-select
          {:id             "photo-deficiency-select"
           :label-text     label-text
           :displayed-text (or (some-> deficiencies (p/find-first {:db/id (first related-entities)}) deficiency-label)
                               (tr [:none]))
           :values         (map :db/id deficiencies)
           :value          related-entities
           :val->str       val->str
           :on-change      #(>evt [::save-deficiencies %])
           :class-name     "w-full min-w-48"}]
         [:div.w-full.min-w-48
          [:label.bx--label label-text]
          [:ul.w-full.list-none.p-2.border.border-solid.border-gray-500
           (if (seq related-entities)
             (futil/for-frag [file-id related-entities]
               [:li.truncate.whitespace-nowrap.w-full.border-b.border-solid.border-gray-300.pb-1.mb-1.last:border-b-0.last:pb-0.last:mb-0
                (val->str file-id)])
             [:li.truncate.whitespace-nowrap.w-full.text-ui-gray-600 (tr [:none])])]])])))


(defn edit-photo-body [{:keys [can-edit? tr] :as options} {:keys [file-id related-deficiencies] :file/keys [description]}]
  (let [photo-preview-href   (file-download/download-href :file/download-workspace-file
                                                          {"file-id" file-id
                                                           "preview" true})
        photo-converted-href (file-download/download-href :file/download-workspace-file
                                                          {"file-id" file-id})
        has-description?     (-> description str/blank? not)]
    [:<>
     [:div.bx--row.items-start
      [:div.bx--col-xs-3.bx--col-md-4.bx--col-lg-6
       [:a
        {:href photo-converted-href}
        [:img {:src photo-preview-href
               :alt (tr [:inspection/attachment])}]]]
      [:div.bx--col-xs-9.bx--col-md-8.bx--col-lg-6
       (if can-edit?
         [ui/text-area {:id          "photo-description"
                        :label-class "w-full"
                        :class       "w-1-1"
                        :label-text  (tr [:inspection/photo-description])
                        :value       description
                        :on-change   #(>evt [::save-description (futil/tval %)])}]
         (when has-description? [:p description]))

       [deficiency-select options related-deficiencies]

       (when (or can-edit? has-description?)
         [ui-sep/horizontal])
       [:div.flex.gap-3
        (cc/button
          {:kind             :tertiary
           :icon             i/download
           :icon-description (tr [:inspection/download-file])
           :href             (file-download/download-href :file/download-workspace-file
                                                          {"file-id"  file-id
                                                           "download" true})}
          (tr [:inspection/download-file]))
        (when can-edit?
          (cc/button
            {:kind     :danger
             :icon     i/trash
             :on-click #(>evt [::set-file-id-to-delete file-id])}
            (tr [:inspection/delete-photo])))]]]]))


(defn- dialog
  [{:keys [tr target-entity] :as options}]
  (let [open?     (boolean (<sub [::edit-photo-modal-open?]))
        curr-file (<sub [::edit-photo-data])
        cancel-fn #(>evt [::close-edit-photo-modal])
        can-edit? (<sub [::process/signal-permitted?
                         target-entity
                         [:process.signal/edit-inspection-file {:file-id (:file-id curr-file)}]])]
    [ui-modal/composed-input-modal
     {:open       open?
      :on-close   cancel-fn
      :class-name "full-width-modal"}
     (cc/modal-header {:close-modal cancel-fn
                       :title       (tr [(if can-edit?
                                           :inspection/edit-new-photo
                                           :inspection/photo)])})
     (when open?
       (cc/modal-body
         [edit-photo-body (assoc options :can-edit? can-edit?) curr-file]))
     (when can-edit?
       (cc/modal-footer
         {}
         (cc/button
           {:kind     :secondary
            :on-click cancel-fn}
           (tr [:cancel]))
         (cc/button
           {:kind     :primary
            :on-click #(>evt [::save-edit-photo-modal target-entity])}
           (tr [:save]))))]))


(defn related-deficiencies-tag [tr file]
  (when (-> file :inspection.deficiency/_photos seq)
    [:span.absolute.bg-black-diagonal.w-12.h-12.right-0.text-right.pr-2.pt-2.text-white
     (cc/icon {:description (tr [:inspection/photo-related-deficiencies])
               :icon        i/link
               :class-name  "fill-current"
               :width       "12"
               :height      "12"})]))


(defn file-preview [{:keys [tr]}
                    {file-id    :db/id
                     :file/keys [number description conversion-pending?]
                     :as        file}]
  (let [show-number? (<sub [::ff/enabled? :feature-flag.id/deficiency-photo-numbering])]
    (if conversion-pending?
      [:div.w-64.h-48.bg-ui-light-gray.border.border-solid.border-ui-gray-200.flex.flex-col.items-center.justify-between.gap-4
       [:div.mt-12 (cc/loading-spinner {:with-overlay false})]
       [:div.pb-2.text-xs.font-bold (tr [:file/generating-thumbnail])]]
      [:div.w-64.h-48.bg-center.bg-cover.relative.cursor-pointer
       {:on-click #(>evt [::open-edit-photo-modal file])
        :style    {:background-image (gstr/format "url('%s')"
                                                  (file-download/download-href :file/download-workspace-file
                                                                               {"file-id" file-id
                                                                                "preview" true}))}}
       [related-deficiencies-tag tr file]
       (when (:recently-added file)
         (cc/icon {:icon        i/check
                   :description (tr [:inspection/successfully-added])
                   :class-name  "bg-ui-green rounded-full m-2 fill-current text-ui-white p-1.5 w-7 h-7"}))
       (let [description (str-util/blank->nil description)
             number      (when show-number? number)]
         (when (or number description)
           [:div.absolute.w-full.bg-black.text-white.p-4.bottom-0.left-0
            (when number [:div.mb-1 number])
            (when description [:div description])]))])))


(defn upload-button [tr on-attach]
  [upload/upload-area
   "inspection-attachment"
   {:attach-file-fn  on-attach
    :additional-help (tr [:inspection/upload-help])
    :accept-types    attachment-model/allowed-image-types}])


(defn section-content [{:keys [tr inspection target-entity visit] :as props}]
  (let [files       (->> (<sub [::entities/entities {:entity/type   :entity.type/file
                                                     :entity/parent (-> inspection :db/id)}])
                         (sort-by :entity/created >))
        can-upload? (<sub [::process/signal-permitted?
                           target-entity
                           [:process.signal/add-inspection-file {:inspection-id (:db/id inspection)}]])]
    [:div
     [:div.flex.flex-row.flex-wrap.gap-6
      (futil/for-frag [file files]
        [file-preview props file])]
     (when (and visit can-upload?)
       [upload-button tr (partial add-inspection-attachment (:db/id inspection) target-entity)])]))


(defn photos-videos-section [{:keys [tr target-entity]
                              :as   props}]
  [:<>
   [section/section
    "inspection-photos-videos"
    props
    (str (tr [:inspection/photos-videos]))
    [section-content props]]

   (if-let [file-id-to-delete (<sub [::file-id-to-delete])]
     [ui/confirm-modal {:tr           tr
                        :id           "delete-photo"
                        :modal-title  (tr [:inspection/delete-photo])
                        :open?        (boolean file-id-to-delete)
                        :on-close     #(>evt [::set-file-id-to-delete nil])
                        :on-yes-click #(>evt [::delete-attachment file-id-to-delete target-entity])}
      (tr [:inspection/delete-photo-are-you-sure])]
     [dialog props])])
